import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// helpers
import { getLocalstorage } from "../../helper";

// actions
import {
  GET_PROJECT_LIST_ACTION,
  CLEAR_ISSUE_OLD_FILTERS_ACTION
} from "../../actions/projectList.action";
import { PROJECT_AWARDED_BY } from "../../constant";
import {
  getDashboardNotifications,
  getDashboardNotificationsAllViewed,
  getNotificationUpdates
} from "../../actions/dashboard.action";

export function ProjectListHoc(WrapperComponent) {
  class ProjectListHocInner extends Component {
    componentDidMount() {
      try {
        const user = getLocalstorage("user");
        const {
          location: { state, isDashBoard, summaryDataBy },
          GET_PROJECT_LIST_ACTION,
          projectListReducer: { selectedFilters },
          getDashboardNotifications,
          getNotificationUpdates
        } = this.props;

        const userSponsoredScheme = getLocalstorage("userSponsoredScheme");
        // is user is PMG then do this
        const groupCategory =
          (isDashBoard && summaryDataBy) || userSponsoredScheme
            ? PROJECT_AWARDED_BY.STATE
            : PROJECT_AWARDED_BY.CENTRAL;
        const isCentral = "CENTRAL";
        let categoryForNotification = isDashBoard
          ? isDashBoard && summaryDataBy
          : userSponsoredScheme;

        let category = categoryForNotification
          ? PROJECT_AWARDED_BY.STATE
          : PROJECT_AWARDED_BY.CENTRAL;

        let params = {};

        //in case of dashboard group category will be selected from params.
        if (isDashBoard) params = { ...state };
        console.log("user groupcategory", user.groupCategory);
        if (
          (user && user.groupCategory === "PMG" && !isDashBoard) ||
          (user.groupCategory === "STATE_PMG" && !isDashBoard) ||
          (user.groupCategory === "STATE" && !isDashBoard) ||
          (user.groupCategory === "DISTRICT" && !isDashBoard) ||
          (user.groupCategory === "STATE_DEPARTMENT" && !isDashBoard)
        ) {
          params["projectStage"] = [
            { key: "VERIFIED", displayName: "VERIFIED" }
          ];
        }
        // call api
        getDashboardNotificationsAllViewed(undefined, category).then(resp => {
          // if (resp && resp.status) getDashboardNotifications();
          if (resp && resp.status) getNotificationUpdates();
        });
        if (
          user.groupCategory === "STATE_PMG" ||
          user.groupCategory === "STATE" ||
          user.groupCategory === "DISTRICT" ||
          user.groupCategory === "STATE_DEPARTMENT"
        ) {
          GET_PROJECT_LIST_ACTION({
            ...selectedFilters,
            groupCategory: isCentral,
            projectFilterType: "ACTIVE",
            ...params
          });
        } else {
          GET_PROJECT_LIST_ACTION({
            ...selectedFilters,
            groupCategory,
            projectFilterType: "ACTIVE",
            ...params
          });
        }
      } catch (error) {
        console.error(error);
      }
    }

    componentWillUnmount() {
      const {
        CLEAR_ISSUE_OLD_FILTERS_ACTION,
        location: { isDashBoard, summaryDataBy }
      } = this.props;
      const userSponsoredScheme = getLocalstorage("userSponsoredScheme");
      const groupCategory =
        (isDashBoard && summaryDataBy) || userSponsoredScheme
          ? PROJECT_AWARDED_BY.STATE
          : PROJECT_AWARDED_BY.CENTRAL;
      CLEAR_ISSUE_OLD_FILTERS_ACTION(groupCategory);
    }

    render() {
      const { props } = this;

      return <WrapperComponent {...props} />;
    }
  }

  function mapStateToProps(state) {
    const { projectListReducer } = state;
    return {
      projectListReducer
    };
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        GET_PROJECT_LIST_ACTION,
        CLEAR_ISSUE_OLD_FILTERS_ACTION,
        getDashboardNotifications,
        getNotificationUpdates
      },
      dispatch
    );
  }

  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ProjectListHocInner)
  );
}
